import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import Footer from "../Footer/NewFooter";
import "../css/home.css";
import "../css/homenew.css";
import {
  Modal,
  Container,
  Row,
  Col,
  Card,
  Button,
  Accordion,
} from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { FaCircle } from "react-icons/fa";
import { Zoom, Fade, Slide, Roll } from "react-reveal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDisconnect } from "wagmi";
import { getUsdtBalance } from "../../Web3/Connector";
import Web3ModalProvider from "../Presale/Connectwallet/Web3ModalProvider";
import {
  getMetadata,
  getContent,
  getPresaleInfiBalance,
  getRecentTransactions,
  getInfiTokenPrice,
  getPresaleStatistics,
  getUsdtAddress,
  GetAllFAQsAction,
  getAllRoadMapAction,
  getPhaseDetails
} from "../../../services/apiServices";
import { Spin } from "antd";
import Swapform from "../Presale/Swapform";
import Cookies from "js-cookie";
import Header from "../Presale/Header";
import { Helmet } from "react-helmet";
import toast, { Toaster } from "react-hot-toast";
import PieChart from "./piechart";

const Home2 = () => {
  const [UsdtContract, setUsdtContract] = useState("");
  const [connectWalletNow, setconnectWalletNow] = useState(false);
  const [IsProcessing, setIsProcessing] = useState(false);
  const [openBuyForm, setOpenBuyForm] = useState(false);
  const [presaleContract, setpresaleContract] = useState("");
  const [roadMap, setroadMap] = useState([]);
  const [content, setContent] = useState("");
  const [InfiTokenPrice, setInfiTokenPrice] = useState(0);
  const [tokenSold, setTokenSold] = useState(0);
  const [presaleInfiBalance, setPresaleInfiBalance] = useState(0);
  const [recentTransactions, setRecentTransactions] = useState([]);
  const [metadata, setMetadata] = useState({});
  const [faqs, setAllfaqs] = useState([]);
  const now = 60;
  const dispatch = useDispatch();
  const _useDisconnect = useDisconnect();
  const [series, setSeries] = useState([35, 15, 9, 35, 6]);
  //  const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const walletConnnected = useSelector((state) => state.auth.walletConnnected);
  const navigate = useNavigate();
  const [WalletAddress, setWalletAddress] = useState("");
  const [usdtBalance, setUsdtBalance] = useState(0);
  const [UsdtAllowance, setUsdtAllowance] = useState(0);
  const [show, setShow] = useState(false);
  const _useWeb3ModalProvider = Web3ModalProvider();
  const [AvailableForSaleInPhase,setAvailableForSaleInPhase] = useState(0)
  const [SoldInPhase,setSoldInPhase] = useState(0)



  const BuyInfiClose = () => {
    setShow(false);
    setOpenBuyForm(false);
  };

  useEffect(() => {
    getUsdtContract();
    getPreSaleContract();
    getInfiPrice();
    recentTrx();
    sold();
    balance();
    cmsContent();
    metadataInfo();
    getAllFaqs();
    getAllRoadMaps();
    phaseInfo()
  }, []);

  const getUsdtContract = async () => {
    const res = await getUsdtAddress();
    if (res.data?.status) {
      setUsdtContract(res.data.data.usdtAddress);
    }
  };
  const getAllRoadMaps = async () => {
    const res = await getAllRoadMapAction();
    if (res?.data?.data.length > 0) {
      setroadMap(res?.data?.data);
    } else {
      setroadMap([]);
    }
  };
  const getAllFaqs = async () => {
    const res = await GetAllFAQsAction();

    if (res?.status) {
      setAllfaqs(res?.data[0]);
    }
  };
  const getPreSaleContract = async () => {
    const res = await getPresaleStatistics();
    if (res.data?.status) {
      setpresaleContract(res.data.data.PreSaleAddress);
    }
  };

  const sold = async () => {
    const res = await getPresaleStatistics();
   // console.log('SOLDD',res)
    if (res.data?.status) {
      setTokenSold(res.data.data.SoldOutToken);
    }
  };

  const phaseInfo = async () => {
    const res = await getPhaseDetails();
    if (res.data?.data && res.data.data.length > 0) {
      const highestIndexEntry = res.data.data[res.data.data.length - 1];
     // console.log('solid',highestIndexEntry.infiAmountAvailableForSell, highestIndexEntry.infiSold);
      setAvailableForSaleInPhase(highestIndexEntry.infiAmountAvailableForSell)
      setSoldInPhase(highestIndexEntry.infiSold)
    } else {
      console.log('solid,No data available');
    }
  }

  const balance = async () => {
    const res = await getPresaleInfiBalance();
    if (res.data?.status) {
      setPresaleInfiBalance(res.data.data);
    }
  };

  const cmsContent = async () => {
    try {
      const res = await getContent();
      setContent(res.data);
    } catch (error) {
      console.log("Error", error);
    }
  };

  const recentTrx = async () => {
    try {
      const res = await getRecentTransactions();
      if (
        res.data.data &&
        Array.isArray(res.data.data) &&
        res.data.data.length > 0
      ) {
        setRecentTransactions(res.data.data);
      } else {
        console.log("No buy transactions found");
      }
    } catch (error) {
      console.log("Error fetching recent buy transactions", error);
    }
  };

  const metadataInfo = async () => {
    try {
      const res = await getMetadata();
      setMetadata(res.data);
    } catch (error) {
      console.log("Error", error);
    }
  };

  const getInfiPrice = async () => {
    const res = await getInfiTokenPrice();
    if (res.data?.status) {
      setInfiTokenPrice(parseFloat(res.data.data.infiprice));
    }
  };

  const [options] = useState({
    chart: {
      width: "100%",
      type: "donut",
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#000000"], // Label text color black
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
    colors: ["#715787", "#353d6e", "#3c6696", "#86eae8", "#4691b8"],
    labels: [
      "Total Infi Sales",
      "Total Reserved for Exchange Liquidity",
      "Reserve Fund",
      "Marketing",
      "@SbSe Protocol Allocation",
    ],
    tooltip: {
      enabled: true,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        colors: "#000000", // Tooltip text color black
      },
      theme: "light", // Ensure background is light for contrast
      y: {
        formatter: function (val) {
          return val + " INFI";
        },
      },
    },
    legend: {
      position: "right",
      offsetY: 0,
      height: 230,
      labels: {
        colors: "#000000", // Legend text color black
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  });

  const appendData = () => {
    const arr = [...series];
    arr.push(Math.floor(Math.random() * (100 - 1 + 1)) + 1);
    setSeries(arr);
  };

  const removeData = () => {
    if (series.length === 1) return;
    const arr = [...series];
    arr.pop();
    setSeries(arr);
  };

  const randomize = () => {
    setSeries(series.map(() => Math.floor(Math.random() * (100 - 1 + 1)) + 1));
  };

  // const reset = () => {
  //   setSeries([10, 15, 20, 25, 30, 35, 40]);
  // };
  // let loginData = !Cookies.get("InfiUser")
  //   ? []
  //   : JSON.parse(Cookies.get("InfiUser"));

  const BuyInfi = async () => {
    if (!walletConnnected) {
      toast.error("Please connect your wallet");
  //    console.log("1234", !walletConnnected, WalletAddress);
      return;
    }

    if (WalletAddress) {
      let res = await getWalelletDetails(WalletAddress);
      //console.log("1111", res, res.status,res.message);
      setShow(true);
    } else {
      setconnectWalletNow(true);
    }
  };
  useEffect(() => {
    document.body.classList.add("lightbody");

    return () => {
      document.body.classList.remove("lightbody");
    };
  }, []);
  useEffect(() => {
    if (walletConnnected) {
      setWalletAddress(walletConnnected);
    }
  }, [walletConnnected]);

  useEffect(() => {
    if (walletConnnected && UsdtContract && presaleContract) {
      getWalelletDetails(walletConnnected);
    }
  }, [walletConnnected, UsdtContract, presaleContract]);
  useEffect(() => {
    setShow(openBuyForm);
  }, [openBuyForm]);

  // const disconnectWallet = () => {
  //   _useDisconnect.disconnect();
  //   dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
  // };

  const getWalelletDetails = async (wallet) => {
    const res = await getUsdtBalance(
      wallet,
      UsdtContract,
      presaleContract,
      _useWeb3ModalProvider
    );
    setUsdtBalance(res?.balance || 0);
    setUsdtAllowance(res?.allowance || 0);
    return res;
  };

  const getEndTime = () => {
    let endTime = localStorage.getItem("countDown");
    const startDate = new Date("2025-06-02");
    let newendTime = startDate.getTime() + 45 * 24 * 60 * 60 * 1000; // 45 days from now
    if (!endTime || parseInt(endTime, 10) !== newendTime) {
      localStorage.setItem("countDown", newendTime);
    }
    return parseInt(endTime, 10);
  };
  const endTime = getEndTime();

  const calculateTimeLeft = () => {
    const difference = endTime - new Date().getTime();

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <Toaster />
      {/* <GeneralNavbar /> */}
      <Header
        showBuyBtn={true}
        setOpenBuyForm={setOpenBuyForm}
        connectWalletNow={connectWalletNow}
        setconnectWalletNow={setconnectWalletNow}
      />
      <Helmet>
        {metadata._keywords && (
          <meta name="keywords" content={metadata._keywords} />
        )}
        {metadata._description && (
          <meta name="description" content={metadata._description} />
        )}
      </Helmet>
      <section className="hero-banner position-relative pt-0 pb-0">
        <div className="bg-video">
          <video width="100%" height="100%" muted loop autoPlay playsInline>
            <source src="assets/images/ico/banner.mp4" type="video/mp4" />
            <source src="assets/images/ico/banner.mp4" type="video/ogg" />
            Your browser does not support the video tag.
          </video>
        </div>
        <Container className=" pt-5">
          <Row
            className="align-items-center pt-5"
            style={{ minHeight: "430px" }}
          >
            <Col lg={6}>
              <Slide top>
                <div className="banner-content position-relative">
                  {/* <div className='slidebtn my-3'>
                                        <Button className='btn-blue px-4 rounded-5 fw-semibold'>&nbsp;</Button>
                                        <Button variant='default' className='px-4 text-black bg-transparent border-0 fw-medium' onClick={BuyInfi}>&nbsp;</Button>

                                    </div> */}
                  <h1 className="secure-swaps fs-1">
                    {content.shaping_the_future}
                    {/* Shaping the Future of Investment <span className='fw-bolder'>With Assured Returns</span> */}
                  </h1>
                  <p className="fs-4">{content.join_the_next}</p>
                </div>
              </Slide>
              <div className="btn-bg mt-5 position-relative">
                <div className="position-relative z-1">
                  <div className="mb-2">
                    {!walletConnnected && (
                      <Button
                        variant="primary"
                        className="text-uppercase text-black fw-bold px-4 rounded-5 btn-register"
                        onClick={(event) => BuyInfi()}
                      >
                        CONNECT YOUR WALLET AND BUY INFI NOW&nbsp;&nbsp;
                        
                        <svg
                          style={{ marginTop: "-3px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="16"
                          viewBox="0 0 24 19"
                          fill="none"
                        >
                          <path
                            d="M15.9223 1.39307L22.803 9.52486M22.803 9.52486L15.9223 17.6566M22.803 9.52486L1.45706 9.52485"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Button>
                    )}
                  {walletConnnected && (
                  <div className="d-flex align-items-center gap-3">
                  <Button
                    variant="primary"
                    className="text-uppercase text-black fw-bold px-4 rounded-5 btn-register"
                    onClick={(event) => BuyInfi()}
                  >
                    Buy Token Now
                  </Button>
                  <img
                    src="assets/images/kycBadges.png"
                    alt="KYC Badges"
                    style={{ height: '49px', objectFit: 'contain' }}
                    onClick={() => window.open("https://app.solidproof.io/projects/inverted-investment", "_blank")}
                  />
                  </div>
                  )}
                  </div>
                  <p className="x-small mb-0">
                    Powered by Inverted Investment's pioneering technology.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={1} className={`cardStyle`}></Col>
            <Col
              lg={5}
              className={`cardStyle tokensalebox position-relative z-2 position-relative`}
            >
{/* <p style={{ color: "red", fontSize: "1.2em", fontWeight: "bold"}}> Donation for Sven Schoenwald</p>
<p style={{ color: "red", fontSize: "1.2em", lineHeight: "1.6" }}>
  All proceeds from this special sale will be fully donated to support the medical treatment of Sven Schoenwald.<br />
  <strong>Price:</strong> 1 USDT/INFI<br />
  <strong>Duration:</strong> Until the fundraising target is achieved<br />
  <em>Thank you for your generous support.</em> <br/>
  <em>You can also donate via: <a href=" https://gofund.me/87cf0287 " target="_blank" rel="noreferrer noopener"> Link</a></em>
</p> */}


              <Zoom>
                <div className="cardBox2 text-center mt-5  mb-3 overflow-hidden">
                  <div className="p-4 tokenBox">
                    <div>
                      <h4 className="text-black fw-bold">Time till price increase</h4>
                    </div>
                    <div className="timer mt-4">
                      <ul>
                        <li>
                          <div className="timerBox">
                            <div className="fs-4 mb-1 countnumber">
                              {String(timeLeft.days).padStart(2, "0")}
                            </div>
                            <div className="fs-6">Days</div>
                          </div>
                        </li>
                        <li>
                          <div className="timerBox">
                            <div className="fs-4 mb-1 countnumber">
                              {String(timeLeft.minutes).padStart(2, "0")}
                            </div>
                            <div className="fs-6">Minutes</div>
                          </div>
                        </li>
                        <li>
                          <div className="timerBox">
                            <div className="fs-4 mb-1 countnumber">
                              {String(timeLeft.seconds).padStart(2, "0")}
                            </div>
                            <div className="fs-6">Seconds</div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="InputRange">
                      <div className="d-flex justify-content-between">
                        <div className="text-start">
                          <h5 className="mb-0 text-black">Sold</h5>
                          <h5 className="text-darkblue fw-bolder">
                            {SoldInPhase.toFixed(3) || ""}
                          </h5>
                        </div>
                        <div className="text-end">
                          <h5 className="mb-0 text-black">Target</h5>
                          <h5 className="text-darkblue fw-bolder">
                            {AvailableForSaleInPhase.toFixed(3) || ""}
                          </h5>
                        </div>
                      </div>
                      <ProgressBar
                        now={(SoldInPhase / AvailableForSaleInPhase) * 100}
                        label={`${now}%`}
                        visuallyHidden
                      />
                      <div className="d-flex justify-content-between px-5">
                        <div className="text-black fw-bold"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="threecoin">
                  <img src="assets/images/ico/threecoin.png" alt="" />
                </div>
              </Zoom>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="EmpowerInvestment position-relative pt-5 pb-0">
        <div className="bg-shape">
          <img alt="" src="assets/images/ico/bg-shape.png" />
        </div>

        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center py-2">
            <Col lg={10}>
              <Zoom bottom>
                <div className="text-center pt-5 pb-5">
                  <h1>{content.empowering_your_investment}</h1>
                  <p className="text-grey">
                    {" "}
                    {content.The_INFI_token_holders_enjoy}
                  </p>
                </div>
              </Zoom>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="Ico position-relative pt-5 pb-5 mb-5 overflow-hidden">
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={12} className="pb-5 mb-5 ">
              <Slide left>
                <div className="position-relative d-inline-block text-left">
                  <div className="polygon">
                    <img src="assets/images/ico/polygon.png" alt="" />
                  </div>

                  <h1 className="fw-light position-relative ">
                    Why be part
                    <br />
                    <span className="fw-bold">of INFI ICO</span>{" "}
                  </h1>
                </div>
                <div className="key_bg">Key Features</div>
              </Slide>
            </Col>
          </Row>
          <Row>
            <Col lg={12} className="position-relative">
              <Row>
                <Col lg={4} className="mb-3">
                  <Roll left>
                    <div className="cardStyle2">
                      <Card className="p-3 cardBox2">
                        <div>
                          <img
                            src="assets/images/ico/icon/liquidity.png"
                            className="infi-icon "
                            alt=""
                          />
                          <h5>Special Liquidity Management</h5>
                          <p className="text-grey">
                            {content.special_liquidity_management}
                          </p>
                        </div>
                      </Card>
                    </div>
                  </Roll>
                </Col>
                <Col lg={4} className="mb-3">
                  <Roll left>
                    <div className="cardStyle2">
                      <Card className="p-3 cardBox2">
                        <div>
                          <img
                            src="assets/images/ico/icon/sbsetrading.png"
                            className="infi-icon "
                            alt=""
                          />
                          <h5>SbSe Trading Rewards</h5>
                          <p className="text-grey">
                            {content.sbse_trading_rewards}
                          </p>
                        </div>
                      </Card>
                    </div>
                  </Roll>
                </Col>
                <Col lg={4} className="mb-3">
                  <Roll left>
                    <div className="cardStyle2">
                      <Card className="p-3 cardBox2">
                        <div>
                          <img
                            src="assets/images/ico/icon/passiveincome.png"
                            className="infi-icon "
                            alt=""
                          />
                          <h5>Monthly Passive Income (SbSe PFP & SbSe BTC)</h5>
                          <p className="text-grey">
                            {content.monthly_passive_income}
                          </p>
                        </div>
                      </Card>
                    </div>
                  </Roll>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <div className="bg-shape2 top-0">
          <img src="assets/images/ico/bg-above.png" alt="" />
        </div>
      </section>
      <section className="Revolutionary position-relative pt-5 pb-0">
        <div className="bg-shape top-0">
          <img
            src="assets/images/ico/r-lock.png"
            className="object-fit-contain"
            alt=""
          />
        </div>

        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center py-2">
            <Col lg={10} className="py-5">
              <Zoom>
                <div className="text-center">
                  <h1>{content.the_revolutionary}</h1>
                  {/* <h1 className='mb-0 fw-bold'>The revolutionary <span className='text-primary-gradient '>©SbSe Protocol,</span></h1> */}

                  <div className="text-start">
                    {/* <p className='fw-light fs-2 mb-4'>heralds a new era of digital payments, as it bridges the gap between real-world enterprises and blockchain networks.</p> */}
                  </div>
                </div>

                <div className="position-relative">
                  <div className="text-start greenline">
                    <p>{content.the_self_builder}</p>
                    {/* /* /* The Self-builder Smart ecosystem (SbSe) Protocol is at the heart of INFI, ensuring a decentralized, efficient, and transparent digital trading environment that enhances security and user autonomy across all transactions.</p> */}
                  </div>
                </div>
              </Zoom>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="Security position-relative pt-5 pb-0">
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center py-2">
            <Col lg={10} className="pb-5 security-card">
              <div className="bookshap">
                <img src="assets/images/ico/book.png" alt="" />
              </div>
              <Card className="bg-transparent border border-dark p-5">
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <Zoom>
                      <div className="security-detail p-md-5 pt-5">
                        <h1 className="mb-0 fw-lighter mb-4">
                          Security and Trust
                        </h1>
                        <p className="fw-light fs-5">
                          {content.security_trust}
                        </p>
                      </div>
                      <div className="buyInfi">
                        <Button
                          variant="default"
                          className="btn-white-gradient text-black px-5 rounded-5 fw-bold position-relative z-2"
                          onClick={BuyInfi}
                        >
                          BUY INFI NOW&nbsp;&nbsp;&nbsp;
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="19"
                            viewBox="0 0 24 19"
                            fill="none"
                          >
                            <path
                              d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button>
                      </div>
                    </Zoom>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
        <div className="bg-shape3 ">
          <img src="assets/images/ico/bg-shape3.png" alt="" />
        </div>
      </section>
      <section className="Ico position-relative pt-5 pb-5 mb-5">
        <Container fluid className="position-relative">
          <Row className="align-items-center">
            <Col lg={12} className="pb-5 text-center">
              <Slide top>
                <div className="position-relative d-inline-block">
                  <div className="polygon bg-step">
                    <img src="assets/images/ico/bg-step.png" alt="" />
                  </div>

                  <h1 className="fw-light position-relative">
                    The ICO <span className="fw-bold">Steps </span>{" "}
                  </h1>
                </div>
              </Slide>
            </Col>
          </Row>

          <Row>
            <Col lg={12} className="position-relative">
              <div className="steps mb-4">
                <ul className="">
                  <li className="d-flex stage1">
                    <Slide left>
                      <div
                        className="d-flex step-content s1"
                        style={{ width: "38%" }}
                      >
                        <div>
                          <p>
                            Beginning with two pre-sale phases where a total of
                            550K of INFI tokens are available at an exclusive
                            price.
                          </p>
                        </div>
                        <div className="step-line ">
                          <img src="assets/images/ico/step-line.png" alt="" />
                        </div>
                      </div>

                      <div
                        className="ellipse1 text-center pt-2 s2"
                        style={{ width: "23%" }}
                      >
                        <h5>1. Pre-sale Stages</h5>
                      </div>
                      <div className="s3" style={{ width: "35%" }}></div>
                    </Slide>
                  </li>
                  <li className="d-flex stage2">
                    <Slide right>
                      <div style={{ width: "35%" }} className="s1"></div>
                      <div
                        className="ellipse1 text-center pt-2 s2"
                        style={{ width: "30%" }}
                      >
                        <h5>2. Launch Price</h5>
                      </div>
                      <div
                        className="d-flex step-content s3"
                        style={{ width: "35%" }}
                      >
                        <div className="step-line ">
                          <img src="assets/images/ico/step-line2.png" alt="" />
                        </div>
                        <div>
                          <p>
                            The INFI tokens broad public release with full-scale
                            trading capabilities, with the price to be announced
                            at the launch.
                          </p>
                        </div>
                      </div>
                    </Slide>
                  </li>
                  <li className="d-flex stage3">
                    <Slide left>
                      <div
                        className="d-flex step-contents1"
                        style={{ width: "35%" }}
                      >
                        <div>
                          <p>
                            The total supply and distribution strategy includes
                            allocations for the ICO (58%), liquidity (15%), and
                            airdrops (12%).
                          </p>
                        </div>
                        <div className="step-line3 ">
                          <img src="assets/images/ico/step-line3.png" alt="" />
                        </div>
                      </div>

                      <div
                        className="ellipse1 text-center pt-2 s2"
                        style={{ width: "35%" }}
                      >
                        <h5>3. Token Distribution</h5>
                      </div>
                      <div style={{ width: "35%" }} className="s3"></div>
                    </Slide>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="position-relative">
          <div className="bg-shape2 bottom-0">
            <img src="assets/images/ico/bg-above.png" alt="" />
          </div>
          <Row>
            <Col xl={4} lg={6}>
              <div className="cardStyle3">
                <Zoom>
                  <Card className="p-3 cardBox">
                    <div>
                      <img
                        src="assets/images/ico/icon/cryptocoin.png"
                        className="infi-icon "
                        alt=""
                      />
                      <h5>Cryptocurrency and Investment Stake</h5>
                      <p className="text-grey">
                        {content.cryptocurrency_investment_stake}
                      </p>
                    </div>
                  </Card>
                </Zoom>
              </div>
            </Col>
            <Col xl={4} lg={6}>
              <div className="cardStyle3">
                <Zoom>
                  <Card className="p-3 cardBox">
                    <div>
                      <img
                        src="assets/images/ico/icon/profitsharing.png"
                        className="infi-icon "
                        alt=""
                      />
                      <h5>Economic Model and Profit Sharing</h5>
                      <p className="text-grey">{content.economic_model}</p>
                    </div>
                  </Card>
                </Zoom>
              </div>
            </Col>
            <Col xl={4} lg={6}>
              <div className="cardStyle3">
                <Zoom>
                  <Card className="p-3 cardBox">
                    <div>
                      <img
                        src="assets/images/ico/icon/digitalintegration.png"
                        className="infi-icon "
                        alt=""
                      />
                      <h5>Digital Integration Across Sectors</h5>
                      <p className="text-grey">{content.digital_integration}</p>
                    </div>
                  </Card>
                </Zoom>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="Ico position-relative pt-5 pb-5 mb-5">
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={12} className="pb-5 text-center">
              <Slide top>
                <div className="position-relative d-inline-block">
                  <h1 className="fw-light position-relative">
                    <span className="text-primary-gradient fw-medium">
                      INFI ICO
                    </span>{" "}
                    <span className="fw-bold bg_pricephase">Price Phases </span>{" "}
                  </h1>
                </div>
              </Slide>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={8} className="position-relative">
              <Zoom>
                <div className="infi-list">
                  <ul>
                    <li>
                      <div>
                        <h5 className="mb-4">
                          <span className="fw-semibold fst-italic">
                            PHASE 1:
                          </span>{" "}
                          <span className="text-blue fw-medium">
                            {content.phase_1}
                          </span>
                        </h5>

                        <h5 className="fw-bold">
                          RESERVED ALLOCATION:{" "}
                          <span className="text-primary-gradient text-break">
                            {content.reserved_1}
                          </span>
                        </h5>
                      </div>
                    </li>
                    <li>
                      <div>
                        <h5 className="mb-4">
                          <span className="fw-semibold fst-italic">
                            PHASE 2:
                          </span>{" "}
                          <span className="text-blue fw-medium">
                            {content.phase_2}
                          </span>
                        </h5>

                        <h5 className="fw-bold">
                          RESERVED ALLOCATION:{" "}
                          <span className="text-primary-gradient text-break">
                            {content.reserved_2}
                          </span>
                        </h5>
                      </div>
                    </li>
                    <li>
                      <div>
                        <h5 className="mb-4">
                          <span className="fw-semibold fst-italic">
                            PHASE 3:
                          </span>{" "}
                          <span className="text-blue fw-medium">
                            {content.phase_3}
                          </span>
                        </h5>

                        <h5 className="fw-bold">
                          RESERVED ALLOCATION:{" "}
                          <span className="text-primary-gradient text-break">
                            {content.reserved_3}
                          </span>
                        </h5>
                      </div>
                    </li>
                    <li>
                      <div>
                        <h5 className="mb-4">
                          <span className="fw-semibold fst-italic">
                            PHASE 4:
                          </span>{" "}
                          <span className="text-blue fw-medium">
                            {content.phase_4}
                          </span>
                        </h5>

                        <h5 className="fw-bold">
                          RESERVED ALLOCATION:{" "}
                          <span className="text-primary-gradient text-break">
                            {content.reserved_4}
                          </span>
                        </h5>
                      </div>
                    </li>
                    {/* <li>
                      <div>
                        <h5 className="mb-4">
                          <span className="fw-semibold fst-italic">
                            PHASE 5:
                          </span>{" "}
                          <span className="text-blue fw-medium">
                            {content.phase_5}
                          </span>
                        </h5>

                        <h5 className="fw-bold">
                          RESERVED ALLOCATION:{" "}
                          <span className="text-primary-gradient text-break">
                            {content.reserved_5}
                          </span>
                        </h5>
                      </div>
                    </li> */}
                  </ul>

                  <div className="text-center" style={{ paddingTop: "40px" }}>
                    {/* <h5 style={{ letterSpacing: "2.625px" }}>
                      TOTAL INFI FOR SALE:
                      <span className="text-blue">
                        {content.total_for_sale}
                      </span>
                    </h5>
                    <h5 style={{ letterSpacing: "2.625px" }}>
                      TOTAL FOR RAISE:
                      <span className="text-blue">
                        {" "}
                        {content.total_for_raise}
                      </span>
                    </h5> */}
                    <h5 className="fw-bold">
                      LAUNCH PRICE:
                      <span className="text-primary-gradient">
                        {content.launch_price_2}
                      </span>
                    </h5>
                  </div>
                </div>
              </Zoom>
            </Col>
          </Row>
        </Container>
        <div className="bg-waveshape">
          <img src="assets/images/ico/bg-wave.png" alt="" />
        </div>
      </section>
      <section className="tokenomics position-relative pt-5 pb-5 mb-5">
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={12} className="pb-5 text-center">
              <Slide top>
                <div className="position-relative d-inline-block">
                  <h1 className="fw-bold position-relative mb-2">
                    INFI TOKENOMICS
                  </h1>
                  {/* <p className="fs-5">
                    INFI is committed to top-tier cybersecurity
                  </p> */}
                </div>
              </Slide>
            </Col>
          </Row>
          <div className="">
            <Row className="justify-content-center align-items-center">
              <Col lg={6} className="position-relative mb-4">
                <Slide left>
                  <div className="tokenomicsList">
                    <div className="mb-4">
                      <h4 className="fw-bold">
                        TOKEN SYMBOL{" "}
                        <img src="assets/images/coin/infi1.svg" width={`60x`} alt=""/>
                      </h4>
                    </div>
                    <div className="mb-5">
                      <p className="text-uppercase mb-3 fs-5">
                        <span className="">TOKEN NAME</span> :{" "}
                        <span className="text-primary-gradient fw-bold">
                          INFI
                        </span>
                      </p>
                      <p className="text-uppercase mb-3 fs-5">
                        <span className="">TOKEN SUPPLY</span> : &nbsp;
                        <span className="text-primary-gradient fw-bold">
                          2,000,000 INFI
                        </span>
                      </p>
                      <p className="text-uppercase mb-3 fs-5">
                        <span className="">OPERATING CHAIN</span> :
                      &nbsp;<span className="text-primary-gradient fw-bold">POLYGON</span>
                      </p>
                      {/* <p className="text-uppercase mb-3 fs-5">
                        <span className="">METAVERSE GAMING</span> :
                      &nbsp;<span className="text-primary-gradient fw-bold">POLYGON</span>
                      </p> */}
                      <a href="https://infimultichain.com/" target="_blank" rel="noreferrer noopener" className="text-white">
                        <p className="text-uppercase mb-3 fs-5">
                          TRADING PLATFORM : INFI MULTICHAIN CDEX
                        </p>
                      </a>
                    </div>
                    <div className="mb-5">
                      <p className="text-uppercase mb-3 fs-5">
                        <span className="">TOTAL SBSE PROTOCOL ALLOCATION</span>{" "}
                        :&nbsp;
                        <span className="text-primary-gradient fw-bold">
                          700,000 INFI LOCKED
                        </span>
                      </p>
                      <p className="text-uppercase mb-3 fs-5">
                        <span className="">TOTAL INFI SALE</span> : &nbsp;
                        <span className="text-primary-gradient fw-bold">
                          700,000 INFI
                        </span>
                      </p>
                      <p className="text-uppercase mb-3 fs-5">
                        <span className="">MARKETING </span>:&nbsp;
                        <span className="text-primary-gradient fw-bold">
                          120,000 INFI
                        </span>
                      </p>
                      <p className="text-uppercase mb-3 fs-5">
                        <span className="">RESERVE FUND</span> : &nbsp;
                        <span className="text-primary-gradient fw-bold">
                          180,000 INFI ~ 24 MONTHS LOCKED
                        </span>
                      </p>
                      <p className="text-uppercase mb-3 fs-5">ALLOCATIONS</p>
                      <p className="text-uppercase mb-3 fs-5">
                        <span className="">
                          TOTAL RESERVED FOR EXCHANGES LIQUIDITY
                        </span>{" "}
                        :&nbsp;
                        <span className="text-primary-gradient fw-bold">
                          300,000 INFI
                        </span>
                      </p>
                      <a href="https://launchpad.infimultichain.com/" target="_blank" rel="noreferrer noopener" className="text-white">
                        <p className="text-uppercase mb-3 fs-5">
                          INFI UPCOMING PRESALE ON INFI LAUNCHPAD
                        </p>
                      </a>
                      <p className="text-uppercase mb-3 fs-5">
                        <span className="">
                          LAUNCH PRICE ON INFI CDEX EXCHANGE
                        </span>{" "}
                        :&nbsp;
                        <span className="text-primary-gradient fw-bold">
                          $5 / INFI
                        </span>
                      </p>
                    </div>
                    <div className="cardStyle2 mb-4">
                      <Card className="cardBox2">
                        <Card.Body>
                          <h4 className="fw-bold text-primary">
                            IMPORTANT NOTICE
                          </h4>
                          <p className="text-uppercase mb-0">
                            INFI WILL BE INITIALLY LISTED ON THE INFI CDEX
                            EXCHANGE WITH A LIMITED LIQUIDITY SUPPLY , LIQUIDITY
                            WILL BE PROGRESSIVELY INCREASED TO STABILIZE THE
                            PRICE AT 5 USDT PER INFI, UNTIL A TOTAL OF 20,000
                            INFI HAS BEEN ALLOCATED TO THE LIQUIDITY POOL{" "}
                          </p>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </Slide>
              </Col>

              {/* <Col lg={4} className="position-relative mb-4">
                <Slide right>
                  <div className="tokenomicsList">
                    <div className="mb-4">
                      <p className="">INFI EWALLET / INFI EBANK 1000000</p>
                      <ProgressBar
                        variant="green"
                        now={now}
                        label={`${now}%`}
                        visuallyHidden
                      />
                    </div>
                    <div className="mb-4">
                      <p className="">SBSE LIQUIDITY HUB 50000</p>
                      <ProgressBar
                        variant="lightblue"
                        now={now}
                        label={`${now}%`}
                        visuallyHidden
                      />
                    </div>
                    <div className="mb-4">
                      <p className="">INFI TREASURY 2500000</p>
                      <ProgressBar
                        variant="purple"
                        now={now}
                        label={`${now}%`}
                        visuallyHidden
                      />
                    </div>
                  </div>
                </Slide>
              </Col> */}
              <Col lg={6} className="position-relative mb-4">
                <Zoom>
                  <div className="chart-wrap">
                    <div id="chart">
                      <PieChart />
                      {/* <ReactApexChart
                        options={options}
                        series={series}
                        type="donut"
                        width={478}
                      /> */}
                    </div>
                  </div>
                </Zoom>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section className="roadmap position-relative pt-5">
        <div className="bg-shape">
          <img
            src="assets/images/ico/leftshape.png"
            className="leftshape position-absolute start-0 top-0 w-50"
            alt=""
          />
          <img
            src="assets/images/ico/rightshape.png"
            className="rightshape position-absolute end-0 top-0 w-50"
            alt=""
          />
        </div>

        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={12} className="pb-5 text-center">
              <Slide top>
                <div className="position-relative d-inline-block">
                  <div
                    className="polygon start-0 end-0"
                    style={{ top: "-54px" }}
                  >
                    <img src="assets/images/ico/polygon3.png" alt="" />
                  </div>
                  <h1 className="fw-light position-relative mb-2">
                    Our Road<span className="fw-bold">Map</span>
                  </h1>
                </div>
              </Slide>
            </Col>
          </Row>
        </Container>
        <Container fluid className="position-relative ">
          <Row className="justify-content-center">
            {/* <Col>
                            <Roadmap/>
                        </Col> */}
            <Col className="position-relative">
              <Zoom>
                <div className="timeline">
                  <ul>
                    <li>
                      <div className="timeline-detail-box">
                        <h1 className="timeline-number">
                          <img src="assets/images/ico/1.png" alt="" />
                        </h1>
                        <div className="dateBox small">Q3 2023-Q4 2024</div>
                        <h3 className="">Phase 1</h3>

                        <div className="phaselist text-white">
                          <p className="small mb-0 d-flex">
                            {/* <div className="down-arrow">
                              <FiArrowDownRight stroke="#11FFBD" />
                            </div> */}

                            <div
                              className="text-break"
                              dangerouslySetInnerHTML={{
                                __html:
                                  roadMap[0]?._description || "Not available",
                              }}
                            ></div>
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="timeline-detail-box">
                        <h1 className="timeline-number">
                          <img src="assets/images/ico/2.png" alt="" />
                        </h1>
                        <h3 className="">Phase 2</h3>
                        <div className="dateBox small">Q4 2024 -Q1 2025</div>
                        <div className="phaselist text-white">
                          <p className="small mb-0 d-flex">
                            <div
                              className="text-break"
                              dangerouslySetInnerHTML={{
                                __html:
                                  roadMap[1]?._description || "Not available",
                              }}
                            ></div>
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="timeline-detail-box">
                        <h1 className="timeline-number">
                          <img src="assets/images/ico/3.png" alt="" />
                        </h1>
                        <h3 className="">Phase 3</h3>
                        <div className="dateBox small">Q1-Q4 2025</div>
                        <div className="phaselist text-white">
                          <p className="small mb-0 d-flex">
                            <div
                              className="text-break"
                              dangerouslySetInnerHTML={{
                                __html:
                                  roadMap[2]?._description || "Not available",
                              }}
                            ></div>
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="timeline-detail-box">
                        <h1 className="timeline-number">
                          <img src="assets/images/ico/4.png" alt="" />
                        </h1>
                        <h3 className="">Phase 4</h3>
                        <div className="dateBox small">Q4 2025-Q4 2026</div>
                        <div className="phaselist text-white">
                          <p className="small mb-0 d-flex">
                            <div
                              className="text-break"
                              dangerouslySetInnerHTML={{
                                __html:
                                  roadMap[2]?._description || "Not available",
                              }}
                            ></div>
                          </p>
                        </div>
                      </div>
                    </li>
                    <li></li>
                  </ul>
                </div>
              </Zoom>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="Security position-relative pt-5 pb-0">
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center py-2">
            <Col lg={12} className="py-5 security-card">
              <Zoom>
                <div className="wallet-icon">
                  <img src="assets/images/ico/icon/wallet.png" alt="" />
                </div>
                <Card className="bg-transparent border border-dark p-4">
                  <Row className="align-items-center justify-content-center">
                    <Col lg={12} className="text-end">
                      <span className="text-danger">
                        <FaCircle className="me-2" />
                        Live Token
                      </span>
                    </Col>
                    <Col xl={5} lg={12}>
                      <div className="security-detail p-lg-5">
                        <h1 className="mb-0 fw-lighter mb-4">Recent active</h1>
                        <div>
                          <img src="assets/images/ico/walletText.png" alt="" />
                        </div>
                      </div>
                    </Col>
                    <Col xl={7} lg={12}>
                      <div className="tableStyle py-5 pt-4">
                        <div className="table-responsive">
                          <table className="w-100">
                            <thead>
                              <tr>
                                {/* <th class="headcol">5Scape</th> */}
                                <th class="headcol">USD</th>
                                <th class="headcol">Wallet</th>
                                <th class="headcol">Date,Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {recentTransactions.map((transaction, index) => (
                                <tr key={index}>
                                  {/* <td class="long text-skyblue">1232456</td> */}
                                  <td class="long">
                                    ${transaction._usdtAmount}
                                  </td>
                                  <td class="long text-skyblue">
                                    <p className="mb-0 walletaddress">
                                      {transaction._walletAddress}
                                    </p>
                                  </td>
                                  <td class="long">
                                    {new Date(
                                      transaction._datetime
                                    ).toLocaleString()}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="buyInfi">
                        <Button
                          variant="default"
                          className="btn-white-gradient text-black px-5 rounded-5 fw-bold "
                          onClick={BuyInfi}
                        >
                          BUY INFI NOW&nbsp;&nbsp;&nbsp;
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="19"
                            viewBox="0 0 24 19"
                            fill="none"
                          >
                            <path
                              d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Zoom>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="InfiIco position-relative pt-5 pb-5 mb-5">
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={12} className="mb-5 pb-5 text-center">
              <Slide top>
                <div className="position-relative d-inline-block text-left">
                  <div className="polygon">
                    <img src="assets/images/ico/polygon2.png" alt="" />
                  </div>

                  <h1 className="fw-light position-relative">
                    How to buy
                    <br />
                    <span className="fw-bold">Without a Hustle</span>{" "}
                  </h1>
                </div>
              </Slide>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={10} className="position-relative">
              <Zoom>
                <Row>
                  <Col lg={6} className="mb-4">
                    <div className="cardStyle2">
                      <Card className="p-4 cardBox2">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <img
                              src="assets/images/ico/icon/1.png"
                              className="infi-icon mb-0"
                              alt=""
                            />
                          </div>
                          <div>
                            <h5>Connect Your Wallet</h5>
                            {/* <p className="text-grey mb-0">
                              Your account and personal identity are guaranteed
                              safe.
                            </p> */}
                            <p className="text-grey mb-0">
                              Before purchasing INFI, kindly register by
                              connecting your wallet. We suggest using MetaMask.
                            </p>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Col>
                  <Col lg={6} className="mb-4">
                    <div className="cardStyle2">
                      <Card className="p-4 cardBox2">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <img
                              src="assets/images/ico/icon/2.png"
                              className="infi-icon mb-0"
                              alt=""
                            />
                          </div>
                          <div>
                            <h5>Check Your Balance on Dashboard </h5>
                            {/* <p className="text-grey mb-0">
                              Buy and sell popular currencies and keep track of
                              them.
                            </p> */}
                            <p className="text-grey mb-0">
                              Once you have successfully made a purchase, your
                              INFI balance will be displayed on the Dashboard.
                            </p>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Col>
                  <Col lg={6} className="mb-4">
                    <div className="cardStyle2">
                      <Card className="p-4 cardBox2">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <img
                              src="assets/images/ico/icon/3.png"
                              className="infi-icon mb-0"
                              alt=""
                            />
                          </div>
                          <div>
                            <h5>Select Payment Method </h5>
                            {/* <p className="text-grey mb-0">
                              Connect the bank account to start transactions.
                            </p> */}
                            <p className="text-grey mb-0">
                              Purchase INFI using USDT (Polygon) and ensure you
                              have 1 Matic for blockchain transaction fees.
                              Please be aware that we only accept this specific
                              cryptocurrency.
                            </p>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Col>
                  <Col lg={6} className="mb-4">
                    <div className="cardStyle2">
                      <Card className="p-4">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <img
                              src="assets/images/ico/icon/2.png"
                              className="infi-icon mb-0"
                              alt=""
                            />
                          </div>
                          <div>
                            <h5>Claim</h5>
                            {/* <p className="mb-0">
                              Buy and sell popular currencies and keep track of
                              them.
                            </p> */}
                            <p className="text-grey mb-0">
                              Transfer your allocated INFI from the Dashboard to
                              your wallet by making a claim.
                            </p>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Col>
                </Row>
              </Zoom>
            </Col>
            <div className="py-5 my-5 m-hide"></div>
          </Row>
        </Container>
      </section>

      <section className="Faqs position-relative pt-0 pb-5 bg-white-gradient">
        <div className="learnBook mb-5">
          <Container className="position-relative">
            <Row>
              <Col lg={6} md={6}>
                <Slide left>
                  <div className="learnBox text-center">
                    <a
                      href="https://linktr.ee/invertedinvestment"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <img src="assets/images/ico/ActionToLearn.png" alt="" />
                      {/* <button type="button" class="btn-blue px-4 rounded-5 btn btn-primary"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 25 28" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.2589 5.26707C21.1457 5.26707 20.2459 6.2581 20.2459 7.47918V19.8361L3.55154 1.49099C2.76444 0.626051 1.49218 0.626051 0.705076 1.49099C-0.0820305 2.35592 -0.0820305 3.75398 0.705076 4.61892L17.3994 22.964H6.15443C5.04121 22.964 4.14137 23.955 4.14137 25.1761C4.14137 26.3972 5.04121 27.3882 6.15443 27.3882H22.2589C23.3721 27.3882 24.272 26.3972 24.272 25.1761V7.47918C24.272 6.2581 23.3721 5.26707 22.2589 5.26707Z" fill="white"></path></svg>&nbsp;Click Here</button> */}
                    </a>
                  </div>
                </Slide>
              </Col>
              <Col lg={6} md={6}>
                <Slide right>
                  <div className="learnBox text-center">
                    <a href='https://launchpad.infimultichain.com/whitepaper' target="_blank"rel="noreferrer noopener">
                      <img src="assets/images/ico/LearnDownload.png" alt="" />
                      {/* <button type="button" class="btn-blue px-4 rounded-5 btn btn-primary"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 25 28" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.2589 5.26707C21.1457 5.26707 20.2459 6.2581 20.2459 7.47918V19.8361L3.55154 1.49099C2.76444 0.626051 1.49218 0.626051 0.705076 1.49099C-0.0820305 2.35592 -0.0820305 3.75398 0.705076 4.61892L17.3994 22.964H6.15443C5.04121 22.964 4.14137 23.955 4.14137 25.1761C4.14137 26.3972 5.04121 27.3882 6.15443 27.3882H22.2589C23.3721 27.3882 24.272 26.3972 24.272 25.1761V7.47918C24.272 6.2581 23.3721 5.26707 22.2589 5.26707Z" fill="white"></path></svg>&nbsp;Click Here</button> */}
                    </a>
                  </div>
                </Slide>
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="position-relative" id="FAQ">
          <Row className="align-items-center justify-content-center">
            <Col lg={8} className="mb-5">
              <Slide top>
                <div className=" text-center">
                  <h1 className="text-uppercase text-white-gradient fw-bold">
                    Frequently Asked Questions{" "}
                  </h1>
                </div>
              </Slide>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={8}>
              <Zoom>
                <div className="accordion">
                  <Accordion defaultActiveKey="0">
                    {faqs?.length > 0 &&
                      faqs.map((item, index) => (
                        <Accordion.Item eventKey={index.toString()} key={index}>
                          <Accordion.Header>
                            {item?._contentQuestion}
                          </Accordion.Header>
                          <Accordion.Body>
                            {item?._contentAnswer}
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                  </Accordion>
                </div>
              </Zoom>
            </Col>
          </Row>
        </Container>
      </section>

      <Modal
        backdrop={"static"}
        onEscapeKeyDown={(e) => e.preventDefault()}
        show={show}
        onHide={BuyInfiClose}
        centered
      >
        <Spin spinning={IsProcessing}>
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>

          <Modal.Body className="">
            <Row className="justify-content-center">
              <Col lg={11}>
                <Swapform
                  usdtBalance={usdtBalance}
                  InfiTokenPrice={InfiTokenPrice}
                  walletConnnected={walletConnnected}
                  UsdtContract={UsdtContract}
                  presaleContract={presaleContract}
                  setIsProcessing={setIsProcessing}
                />
              </Col>
            </Row>
          </Modal.Body>
        </Spin>
      </Modal>

      <Footer />
    </>
  );
};

export default Home2;
